if (!customElements.get('header-minimal')) {
  customElements.define(
    'header-minimal',
    class HeaderMinimal extends HTMLElement {
      connectedCallback() {
        this.scrollThreshold = 16;
        this.ticking = false;
        this.isFixed = false;
        this.mobileDetails = Array.from(
          this.querySelectorAll('.header-minimal__mobile-search, .header-minimal__mobile-menu')
        );

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onDetailsToggle = this.onDetailsToggle.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.updateHeaderHeight();
        this.updateState();

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        document.addEventListener('click', this.onDocumentClick);
        this.mobileDetails.forEach((details) => details.addEventListener('toggle', this.onDetailsToggle));
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('click', this.onDocumentClick);
        this.mobileDetails.forEach((details) => details.removeEventListener('toggle', this.onDetailsToggle));
        this.classList.remove('is-fixed', 'is-visible', 'is-scrolled');
        document.body.classList.remove('header-minimal-has-fixed', 'header-minimal-search-open');
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;

        window.requestAnimationFrame(() => {
          this.updateState();
          this.ticking = false;
        });
      }

      onResize() {
        this.updateHeaderHeight();
      }

      onDetailsToggle(event) {
        this.updateSearchOpenState();
        if (!event.target.open) return;

        this.mobileDetails.forEach((details) => {
          if (details !== event.target) details.open = false;
        });
        this.updateSearchOpenState();

        if (event.target.classList.contains('header-minimal__mobile-search')) {
          window.requestAnimationFrame(() => {
            event.target.querySelector('input[type="search"]')?.focus();
          });
        }
      }

      onDocumentClick(event) {
        if (this.contains(event.target)) return;
        this.mobileDetails.forEach((details) => {
          details.open = false;
        });
        this.updateSearchOpenState();
      }

      updateSearchOpenState() {
        const searchIsOpen = this.querySelector('.header-minimal__mobile-search')?.open;
        document.body.classList.toggle('header-minimal-search-open', Boolean(searchIsOpen));
      }

      updateHeaderHeight() {
        const height = Math.ceil(this.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--header-minimal-fixed-height', `${height}px`);
      }

      setFixedState(shouldFix) {
        if (shouldFix === this.isFixed) return;
        this.isFixed = shouldFix;

        if (shouldFix) {
          this.updateHeaderHeight();
          document.body.classList.add('header-minimal-has-fixed');
          this.classList.add('is-fixed', 'is-scrolled');
          window.requestAnimationFrame(() => {
            this.classList.add('is-visible');
          });
          return;
        }

        this.classList.remove('is-visible', 'is-fixed', 'is-scrolled');
        document.body.classList.remove('header-minimal-has-fixed');
      }

      updateState() {
        const shouldFix = window.scrollY > this.scrollThreshold;
        this.setFixedState(shouldFix);
        if (shouldFix) this.updateHeaderHeight();
      }
    }
  );
}
